<template>
  <div>
    <h1><i class="fa fa-file-code-o"></i> Example Data</h1>
    <div class="row">
      <div class="col-lg-6 col-sm-12">
        <div class="qm-panel qm-panel-left">
          <div id="qm-survey-import-buttons">
            <h2>Import</h2>
            <button v-on:click="importResources" type="button" class="btn  btn-turquois qm-survey-edit-button ripple">Resources</button>
            <button v-on:click="importMainData" type="button" class="btn  btn-turquois qm-survey-edit-button ripple">Main Data</button><br />
            <h3>Resources</h3>
            <button id="import-example-room-names" v-on:click="importExampleRoomNames" type="button" class="btn  btn-turquois qm-survey-edit-button ripple">Room Names</button>
            <button id="import-example-standard-survey-items" v-on:click="importExampleStandardSurveyItems" type="button" class="btn btn-turquois qm-survey-edit-button ripple">Standard Survey Items</button>
            <button id="import-example-modes" v-on:click="importExampleModes" type="button" class="btn btn-turquois qm-survey-edit-button ripple">Modes</button>
            <button id="import-example-countries" v-on:click="importExampleCountries" type="button" class="btn btn-turquois qm-survey-edit-button ripple">Countries</button>
            <button id="import-example-vehicletypes" v-on:click="importExampleVehicleTypes" type="button" class="btn btn-turquois qm-survey-edit-button ripple">Vehicle Types</button>
            <button id="import-example-crates" v-on:click="importExampleCrates" type="button" class="btn btn-turquois qm-survey-edit-button ripple">Crates</button>
            <button id="import-example-legal-notes" v-on:click="importExampleLegalNotes" type="button" class="btn btn-turquois qm-survey-edit-button ripple">Legal Notes</button>
            <h3>Main Data</h3>
            <button id="import-example-surveys" v-on:click="importExampleSurveys" type="button" class="btn  btn-turquois btn-turquois qm-survey-edit-button ripple">Surveys</button>
            <button id="import-example-rooms" v-on:click="importExampleRooms" type="button" class="btn  btn-turquois btn-turquois qm-survey-edit-button ripple">Rooms</button>
            <button id="import-example-items" v-on:click="importExampleItems" type="button" class="btn  btn-turquois qm-survey-edit-button ripple">Items</button>
            <button id="import-example-resources" v-on:click="importExampleResources" type="button" class="btn  btn-turquois qm-survey-edit-button ripple">Resources</button>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-sm-12">
        <div class="qm-panel">
          <div id="qm-survey-clear-buttons">
            <h3>Clear</h3>
            <button v-on:click="clearLocalStorage" type="button" class="btn btn-danger qm-survey-edit-button ripple mb-3"><i class="fa fa-times"></i> Clear Local Storage</button>
            <ul id="qm-survey-clear-buttons-results" class="list-group"></ul>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-sm-12">
        <div v-if="importResults.length > 0" class="import-results">
          <div class="qm-panel">
            <h2>Results</h2>
            <div v-for="importResult in importResults" :class="importResult.style" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span>&times;</span>
              </button>
              {{ importResult.message }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import $ from 'jquery'
import Login from './children/Login.vue'
import exampleSurveys from '../data/Surveys.json'
import exampleRooms from '../data/Rooms.json'
import exampleRoomNames from '../data/RoomNames.json'
import exampleItems from '../data/Items.json'
import exampleResources from '../data/Resources.json'
import exampleStandardSurveyItems from '../data/StandardSurveyItems.json'
import exampleModes from '../data/Modes.json'
import exampleCountries from '../data/Countries.json'
import exampleVehicleTypes from '../data/VehicleTypes.json'
import exampleCrates from '../data/Crates.json'
import exampleLegalNotes from '../data/LegalNotes.json'

export default {
  name: 'Sync',
  components: {
    'login': Login
  },
  data: () => ({
    username: '',
    password: '',
    authenticated: false,
    importResults: []
  }),
  methods: {
    importMainData: function () {
      this.importExampleSurveys()
      this.importExampleRooms()
      this.importExampleItems()
      this.importExampleResources()
    },
    importResources: function () {
      this.importExampleRoomNames()
      this.importExampleStandardSurveyItems()
      this.importExampleModes()
      this.importExampleCountries()
      this.importExampleVehicleTypes()
      this.importExampleCrates()
      this.importExampleLegalNotes()
    },
    importExampleSurveys: function () {
      this.$store.dispatch('importSurveys', exampleSurveys).then(() => {
        $('#import-example-surveys').addClass('qm-button-checked')
      })
    },
    importExampleRooms: function () {
      this.$store.dispatch('importRooms', exampleRooms).then(() => {
        $('#import-example-rooms').addClass('qm-button-checked')
      })
    },
    importExampleItems: function () {
      this.$store.dispatch('importItems', exampleItems).then(() => {
        $('#import-example-items').addClass('qm-button-checked')
      })
    },
    importExampleResources: function () {
      this.$store.dispatch('importResources', exampleResources).then(() => {
        $('#import-example-resources').addClass('qm-button-checked')
      })
    },
    importExampleRoomNames: function () {
      this.$store.dispatch('importRoomNames', exampleRoomNames).then(() => {
        $('#import-example-room-names').addClass('qm-button-checked')
      })
    },
    importExampleStandardSurveyItems: function () {
      this.$store.dispatch('importStandardSurveyItems', exampleStandardSurveyItems).then(() => {
        $('#import-example-standard-survey-items').addClass('qm-button-checked')
      })
    },
    importExampleModes: function () {
      this.$store.dispatch('importModes', exampleModes).then(() => {
        $('#import-example-modes').addClass('qm-button-checked')
      })
    },
    importExampleCountries: function () {
      this.$store.dispatch('importCountries', exampleCountries).then(() => {
        $('#import-example-countries').addClass('qm-button-checked')
      })
    },
    importExampleVehicleTypes: function () {
      this.$store.dispatch('importVehicleTypes', exampleVehicleTypes).then(() => {
        $('#import-example-vehicletypes').addClass('qm-button-checked')
      })
    },
    importExampleCrates: function () {
      this.$store.dispatch('importCrates', exampleCrates).then(() => {
        $('#import-example-crates').addClass('qm-button-checked')
      })
    },
    importExampleLegalNotes: function () {
      this.$store.dispatch('importLegalNotes', exampleLegalNotes).then(() => {
        $('#import-example-legal-notes').addClass('qm-button-checked')
      })
    },
    clearLocalStorage: function () {
      $('#qm-survey-clear-buttons-results').empty()
      const actions = [
        'clearSurveysStorage',
        'clearRoomsStorage',
        'clearItemsStorage',
        'clearResourcesStorage',
        'clearSignaturesStorage',
        'clearFotosStorage',
        'clearRoomNameStorage',
        'clearStandardSurveyItemsStorage',
        'clearModesStorage',
        'clearCountriesStorage',
        'clearCratesStorage',
        'clearLegalNotesStorage'
      ]
      actions.forEach((action) => {
        $('#qm-survey-clear-buttons-results').empty()
        this.$store.dispatch(action).then(() => {
          $('#qm-survey-clear-buttons-results').append('<li class="list-group-item">' + action + '</li>')
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Import.vue